// extracted by mini-css-extract-plugin
export var borderRadius = "_6y-4";
export var large = "_6y-3";
export var logoContainer = "_6y-0";
export var nameLogo = "_6y-2";
export var small = "_6y-1";